import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const GmailCallback = () => {
  const [status, setStatus] = useState('connecting');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setStatus('error');
      return;
    }

    const connectGmail = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const resp = await fetch(`${API_URL}/api/gmail/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ code }),
        });

        if (!resp.ok) throw new Error('Failed to connect');

        setStatus('success');
        setTimeout(() => navigate('/dashboard'), 2000);
      } catch {
        setStatus('error');
      }
    };

    connectGmail();
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: '96px 24px', textAlign: 'center', maxWidth: 480, margin: '0 auto' }}>
      {status === 'connecting' && <p>Connecting your Gmail...</p>}
      {status === 'success' && <p>Gmail connected successfully! Redirecting...</p>}
      {status === 'error' && <p>Failed to connect Gmail. <a href="/dashboard">Go back</a></p>}
    </div>
  );
};

export default GmailCallback;
